export function header() {
  const mv = document.querySelector(".c-mv");
  const headerEl = document.getElementById("js-header");

  if (!mv || !headerEl) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        headerEl.classList.toggle("_is-active", !entry.isIntersecting);
      });
    },
    {
      rootMargin: `-${headerEl.offsetHeight}px 0px 0px 0px`,
      threshold: 0,
    }
  );

  observer.observe(mv);
}
